<template>
  <div class="page">
    <box fill>
      <el-form label-position="right" label-width="80px" class="EL-Form">
        <el-col :lg="10" :xl="10">
          <el-form-item label="交易时间" class="EL-Form-Item">
            <el-date-picker
              style="width: 350px"
              v-model="searchInfo.date"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <!-- <el-col :lg="5" :xl="5">
          <el-form-item label="开始日期" class="EL-Form-Item">
            <el-date-picker v-model="searchInfo.beginTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" default-time="00:00:00" placeholder="开始日期"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="结束日期" class="EL-Form-Item">
            <el-date-picker v-model="searchInfo.endTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" default-time="23:59:59" placeholder="结束日期"></el-date-picker>
          </el-form-item>
        </el-col> -->
        <el-col :lg="4" :xl="4">
          <el-form-item class="btn-edit-delete EL-Form-Item">
            <el-button class="btn-t-edit" @click="getMainData()">查询</el-button>
            <el-button class="btn-t-delete" @click="resetData()">重置</el-button>
          </el-form-item>
        </el-col>
      </el-form>
      <el-divider></el-divider>
      <plabel text="绩效统计报表">
        <el-button v-authority="'BACK_MENU7_M14_B2'" class="btn-t-detail" type="primary" size="small" @click="barChart()">生成柱状图</el-button>
        <el-button v-authority="'BACK_MENU7_M14_B1'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
      </plabel>
      <!-- 展示 -->
      <h-table :headerCellStyle="headerCellStyle"
        style="flex: 1"
        @pageChange="getMainData"
        :data="mainData"
        pagination
        :nowPage.sync="pagination.pageNum"
        :pageSize.sync="pagination.pageSize"
        :total.sync="pagination.total"
      >
        <!-- <el-table-column prop="fcCode" label="工厂编号" /> -->
        <el-table-column prop="createMonth" label="交易时间" />
        <el-table-column prop="personNumber" label="仓库人员工号" />
        <el-table-column prop="userName" label="仓库人员名称" />
        <el-table-column prop="shouhuo" label="收货次数" />
        <el-table-column prop="tuiliao" label="退料次数" />
        <el-table-column prop="waixie" label="外协次数" />
        <el-table-column prop="shangjia" label="上架次数" />
        <el-table-column prop="peisong" label="配送次数" />
      </h-table>
    </box>

		<!-- 生成柱状图 -->
		<el-dialog title="柱状图" :visible.sync="echartShow" class="infoDialog" :close-on-click-modal="false" :show-close="true">
			<div class="echarts-box" ref="echarts"></div>
		</el-dialog>
  </div>
</template>
<script>
import moment from "moment";
import * as echarts from "echarts"; // 导图全局 echarts
export default {
  name: "WriteXaAchievements",
  data() {
    return {
      headerCellStyle: () => {
        return "background-color: #1f5cec";
      },
      form: {},
      //主数据
      mainData: [],
      pagination: {
        pageNum: 1,
        pageSize: 50,
        total: 0,
      },
      searchInfo: {
        matCode: "",
        lcCode: "",
        fcCode: localStorage.getItem("fcCode") || "",
        // beginTime: moment().format("YYYY-MM-DD HH:mm:ss"), // 开始时间
        // endTime: moment().format("YYYY-MM-DD HH:mm:ss"), // 结束时间
        date: [],
      },
      taskTab: "0",

      downloadLoading: false, //下载中

      logContent: "", //操作日志-内容
      logRemarks: "", //操作日志-备注
      // 输入框延时加载
      isSetTimeout: null,

			echartShow: false,
    };
  },
  watch: {
    searchInfo: {
      handler(newVal) {
        clearTimeout(this.isSetTimeout);
        this.isSetTimeout = setTimeout(() => {
          this.getMainData(newVal);
        }, 1000);
      },
      deep: true,
    },
  },
  methods: {
		setPieChart(dimensions,source,series) {
			this.$nextTick(() => {
				var myChart = echarts.init(this.$refs.echarts);
				var optionChart = {
					legend: {},
					tooltip: {},
					dataset: {
						dimensions: dimensions,
						source: source
					},
					xAxis: { type: 'category' },
					yAxis: {},
					series: series
				};
				myChart.setOption(optionChart);
  		});
		},
    // 节流搜索
    saveSearch() {
      if (window.lazy) window.clearTimeout(window.lazy);
      window.lazy = window.setTimeout(() => {
        this.getMainData();
      }, 1000);
    },
    //获取数据
    getMainData() {
      this.$http
        .request({
          url: "/api/xa/getXaAchievements",
          method: "GET",
          params: {
            // fcCode: this.searchInfo.fcCode || null,
            pageNum: this.pagination.pageNum,
            pageSize: this.pagination.pageSize,
            beginTime: this.searchInfo.date ? this.searchInfo.date[0] : null,
            endTime: this.searchInfo.date ? this.searchInfo.date[1] : null,
          },
        })
        .then((resp) => {
          this.loading--;
          if (resp.status == 100) {
            this.mainData = resp.data.list || [];
            this.pagination.total = resp.data.total;
          }
        })
        .catch((error) => {
          this.loading--;
        });
    },

		//柱状图
		barChart(){
			let data = this.mainData || [];
			if(data.length==0){
				this.$message({
					message: "当前查询无结果",
					type: "warning",
				});
				return;
			}
			
			this.$http
        .request({
          url: "/api/xa/getXaAchievementsChart",
          method: "GET",
          params: {
            // fcCode: this.searchInfo.fcCode || null,
            beginTime: this.searchInfo.date ? this.searchInfo.date[0] : null,
            endTime: this.searchInfo.date ? this.searchInfo.date[1] : null,
          },
        })
        .then((resp) => {
          this.loading--;
          if (resp.status == 100) {
            let listMap = resp.data;
						this.echartShow = true;
						this.setPieChart(listMap.dimensions,listMap.source,listMap.series);
          }
        })
        .catch((error) => {
          this.loading--;
        });
		},
    //重置
    resetData() {
      this.pagination = {
        pageNum: 1,
        pageSize: 50,
        total: 0,
      };
      this.searchInfo = {
        fcCode: localStorage.getItem("fcCode") || "",
        // beginTime: moment().format("YYYY-MM-DD HH:mm:ss"), // 开始时间
        // endTime: moment().format("YYYY-MM-DD HH:mm:ss"), // 结束时间
        date: [],
      };
      //添加默认时间
      this.searchInfo.date.push(moment().subtract(3, 'month').format("YYYY-MM-DD HH:mm:ss"));
      this.searchInfo.date.push(moment().format("YYYY-MM-DD HH:mm:ss"));
      this.getMainData();
    },

    //表格导出
    downLoadFile() {
      this.downloadLoading = true;
      var paramsObj = {
        fcCode: this.searchInfo.fcCode || null,
        beginTime: this.searchInfo.date ? this.searchInfo.date[0] : null,
        endTime: this.searchInfo.date ? this.searchInfo.date[1] : null,
        pageNum: 1,
        pageSize: 999999,
      };

      this.$http
        .request({
          url: "/api/xa/getXaAchievements",
          method: "GET",
          showLoading: true,
          params: paramsObj,
        })
        .then((resp) => {
          resp.status == 100
            ? this.downLoad(resp.data.list || [])
            : this.$notify.error({
                message: "查询失败",
              });
        });
    },
    downLoad(list) {
      import("@/libs/Export2Excel").then((excel) => {
        const tHeader = [
          // "工厂编号",
          "交易时间",
          "仓库人员工号",
          "仓库人员名称",
          "收货次数",
          "退料次数",
          "外协次数",
          "上架次数",
          "配送次数",
        ];

        const filterVal = [
          // "fcCode",
          "createMonth",
          "personNumber",
          "userName",
          "shouhuo",
          "tuiliao",
          "waixie",
          "shangjia",
          "peisong",
        ];
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "绩效统计报表数据",
        });
        this.logContent = "导出";
        this.logRemarks = "write_xa：导出绩效统计报表数据";
        this.systemLog();
        this.downloadLoading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },

    /**
     * 操作日志
     */
    systemLog() {
      let objData = {
        logType: "绩效统计报表",
        logContent: this.logRemarks || "",
        //logRemarks: this.logRemarks || "",
        logUser: localStorage.getItem("user") || "",
      };
      this.$http
        .request({
          url: "api/log/insert",
          method: "POST",
          data: objData,
        })
        .then((resp) => {
          this.logContent = "";
          this.logRemarks = "";
          if (resp.status == 100) {
          }
        })
        .catch((error) => {});
    },
  },
  activated() {
    //添加默认时间
    this.searchInfo.date = [];
    this.searchInfo.date.push(moment().subtract(3, 'month').format("YYYY-MM-DD HH:mm:ss"));
    this.searchInfo.date.push(moment().format("YYYY-MM-DD HH:mm:ss"));

    /* 获取首页的数据 */
    // this.getMainData();
  },
};
</script>

<style scoped>
.echarts-box {
  min-height: 400px;
}
</style>